import React, { useState, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import "../../components/alerts/InfoMessage.js";
import "../../components/alerts/NoAccessInfoMessage.js";
import "@mui/material";
import "../../components/alerts/Message.style.js";
import { LocalizedText } from "../../components/i18n/LocalizedText.js";
import "../../components/alerts/InfoAlert.js";
import { withInfoMessage } from "../../components/alerts/InfoMessageHoc.js";
import "../../components/autocomplete/Autocomplete.styles.js";
import "../../components/autocomplete/Autocomplete.localize.js";
import "react-virtualized-auto-sizer";
import "react-window";
import "@mui/icons-material";
import "@mui/x-tree-view";
import "../../components/tree-view/TreeViewItemExpandableOption.js";
import "../../components/autocomplete/AutocompleteInfoMessage.js";
import "../../components/icons/Icon.js";
import "../../components/icons/ExpandMoreIcon.js";
import "../../components/input/validation.js";
import "../../components/input/DatePicker.js";
import "../../components/input/DateRangePicker.js";
import "../../components/input/StyledInput.js";
import "../../components/input/FormInput.js";
import { withStyledInputLabel } from "../../components/input/StyledFormInputHoc.js";
import { isStringNullOrEmpty } from "../../utils/string.js";
import "moment-timezone";
import "react-intl";
import "../../components/input/DateSinglePicker.localize.js";
import "../../components/input/hooks.js";
import "fast-deep-equal/es6";
import "@mui/material/CircularProgress";
import "@mui/material/TextField";
import "../../components/button/Buttons.js";
import "../../components/button/EditButton.js";
import { Autocomplete } from "../../components/autocomplete/Autocomplete.js";
import "../../components/tree-view/TreeViewItemSelectOption.js";
import "../../components/autocomplete/AutocompleteButton.js";
import { dashCharacter } from "../../components/label/EmptyLabel.js";
import "../../components/label/LabelHoc.js";
import "typesafe-actions";
import { extendedViewCleanDelay } from "../../redux-folder/view/types.js";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
const useClasses = makeStyles()((theme) => ({
  viewAutocomplete: {
    width: "100%",
    height: "32px"
  },
  viewAutocompletePopupIndicator: {
    padding: 0,
    marginTop: theme.spacing(-1),
    "&:hover": {
      background: "none"
    }
  }
}));
const ViewAutocomplete = ({
  viewType,
  entityType,
  displayName,
  fields,
  optionMapper,
  value,
  filter,
  filterKey,
  filterMapper,
  valueMapper,
  validateFilter,
  isDisabled,
  placeholder,
  optionsLimit = 20,
  onValueChange,
  onOptionChange,
  onOptionsChange,
  mode,
  hasLargeOptions,
  errorMessage,
  errorMessageOrientation,
  multiple,
  loading,
  cleanDelay = extendedViewCleanDelay
}) => {
  const { classes } = useClasses();
  const [inputValue, setInputValue] = useState("");
  const {
    items,
    handleFilterChange: handleViewEntityFilterChange,
    viewEntity: { status }
  } = useViewInit({
    viewType,
    displayName,
    entity: {
      entity: entityType,
      fields
    },
    defaultPaging: { page: 1, pageSize: optionsLimit },
    defaultFilters: [{ key: filterKey, value: filter?.[filterKey] }],
    cleanDelay,
    validateFilter
  });
  const [hasChanges, setHasChanges] = useState(false);
  const autocompleteValue = multiple ? value?.map(valueMapper) : valueMapper(value);
  const { options, selectedOption } = getOptions(value);
  useEffect(() => {
    setHasChanges(filter?.[filterKey] !== autocompleteValue);
  }, [autocompleteValue]);
  useEffect(() => {
    if (onOptionsChange) {
      onOptionsChange(options, inputValue);
    }
  }, [options?.map((o) => o.value)?.join()]);
  function handleValueChange(option) {
    if (onValueChange) {
      const value2 = multiple ? option?.map((o) => o.value) : option?.value;
      onValueChange(value2 ?? null);
    }
    if (onOptionChange) {
      onOptionChange(option);
    }
  }
  function handleFilterChange(value2) {
    if (mode === "server") {
      handleViewEntityFilterChange([
        {
          key: filterKey,
          value: filterMapper ? filterMapper(value2) : value2
        }
      ]);
    }
    setHasChanges(value2 !== autocompleteValue);
    setInputValue(value2);
  }
  function getOptions(value2) {
    let allOptions = [];
    if (!items?.length && value2 && !hasChanges) {
      allOptions = multiple ? value2?.map(optionMapper) : [optionMapper(value2)];
    } else {
      allOptions = items?.reduce((result, i) => {
        const option = optionMapper(i);
        return option?.value ? [...result, option] : result;
      }, []);
    }
    return {
      options: allOptions?.sort((a, b) => a.label?.localeCompare(b.label)),
      selectedOption: getSelectedOption(allOptions, value2)
    };
  }
  function getSelectedOption(options2, value2) {
    let result;
    if (multiple) {
      const optionValues = value2?.map((o) => valueMapper(o));
      result = [];
      optionValues?.forEach((o) => {
        result?.push(options2?.find((i) => i.value === o));
      });
      result = options2?.filter((i) => optionValues?.includes(i.value));
    } else {
      result = options2?.find((i) => i.value === valueMapper(value2));
    }
    return result;
  }
  function getDisableLabel(selectedOption2) {
    return !isStringNullOrEmpty(selectedOption2?.label) ? selectedOption2?.label : dashCharacter;
  }
  function getMultipleModeDisableLabel(selectedOptions) {
    return selectedOptions?.length ? selectedOptions?.map((o) => o.label).join() : dashCharacter;
  }
  const loadingValue = loading || value?.length && !selectedOption?.length || status === "inProgress";
  return isDisabled ? /* @__PURE__ */ React.createElement(
    LocalizedText,
    {
      label: multiple ? getMultipleModeDisableLabel(selectedOption) : getDisableLabel(selectedOption)
    }
  ) : /* @__PURE__ */ React.createElement(
    Autocomplete,
    {
      multiple,
      dataTestId: viewType,
      classes: {
        root: classes.viewAutocomplete,
        popupIndicator: classes.viewAutocompletePopupIndicator
      },
      value: autocompleteValue,
      options,
      onValueChange: handleValueChange,
      onFilterChange: handleFilterChange,
      placeholder: placeholder ?? displayName,
      optionsLimit,
      allowEmptyValue: true,
      defaultOption: selectedOption,
      errorMessage,
      loading: loadingValue,
      errorMessageOrientation,
      hasLargeOptions,
      mode,
      useValueAsDefaultInputValue: true
    }
  );
};
const StyledViewAutocomplete = withStyledInputLabel(ViewAutocomplete);
const ViewAutocompleteWithInfoMessage = withInfoMessage(ViewAutocomplete);
export {
  StyledViewAutocomplete,
  ViewAutocomplete,
  ViewAutocompleteWithInfoMessage
};
//# sourceMappingURL=ViewAutocomplete.js.map
